import React from "react";
import { Link } from "react-router";
import "../../styles/demo.css";
import "../../styles/template.css";
import ButtonsAndIcons from "./buttonsAndIcons";
import Icons from "./icons";
import CheckboxAndSwitchers from "./checkboxSwitchers";
import InputComponents from "./inputComponents";
import Landing from "./navigation";
import ListViewDemo from "./listView";
import Popups from "./popups";
import ProductBrowser from "./productBrowser";
import ThemePicker from "./themePicker";
import Typeface from "./typeface";
import TableDemo from "./tableDemo";
import DarkModeToggle from "../../components/shared/darkModeToggle";
import TabStrip from "../../components/shared/tabstrip";
import Tab from "../../components/shared/tabstrip/tab";
import RoleLayout from "./roleLayout";
import Layout from "./layout";
import Button from "../../components/shared/button";
import Colors from "./Colors";
import Switchable from "../../components/Switchable";
import Form from "./form";
import GridLayout from "./gridLayout";
import Material from "./material";

const Template: React.FC = () => {
  return (
    <>
      <group
        data-wrap="no"
        data-border=""
        data-space="10"
        data-background="main-background"
        data-align="center"
        data-gap="10"
      >
        <Link to="../">
          <Button className="button mini rounded">
            <icon>home</icon>
          </Button>
        </Link>
        <separator data-vertical=""></separator>

      
        <group
          data-wrap="no"
          data-align="center"
          data-gap="10"
          data-position="right"
          data-width="auto"
        >
          <text
            light="" //NOSONAR
            data-ellipsis=""
            data-adaptive="desktop"
          >
            Dark Mode Switcher
          </text>
          <DarkModeToggle />
        </group>
      </group>

      <view data-vertical data-index="2">
        <Switchable
          data-switch-size="60"
            defaultExpanded={false}
          icon="palette"
          data-type="overlap"
          data-length="60"

          data-timing="fancy"
          data-duration=".225"
          

          togglerProps={{
            "data-adaptive": "mobile",
            "data-order": "2",
            "data-justify":"center",
            // "data-background": "main",
            // "data-color": "white",
          }}
        >
          <view
            data-border=""
            data-background="main-background"
            data-length="60"
          >
            <ThemePicker />
          </view>
        </Switchable>

        <view>
          <space data-height="10"></space>
          <TabStrip
            onChange={(index) => {
              console.log(index);
            }}
            skipSecondaryTabs={false}
            selectedIndex={0}
            //  id="myTabStrip"
          >
            <Tab title="Typeface">
              <Typeface />
            </Tab>
            <Tab title="Colors & Background">
              <Colors />
            </Tab>
            <Tab title="Layout">
              <Layout />
            </Tab>
            <Tab title="Icons" primary>
              <Icons />
            </Tab>
            <Tab title="Buttons & Badges" primary>
              <ButtonsAndIcons />
            </Tab>

            <Tab title="Checkbox & Switchers" primary>
              <CheckboxAndSwitchers />
            </Tab>
            <Tab title="Input Components" primary>
              <InputComponents />
            </Tab>
            <Tab title="Form" primary>
              <Form />
            </Tab>
            <Tab title="List view" primary>
              <ListViewDemo />
            </Tab>
            <Tab title="Popups" primary>
              <Popups />
            </Tab>
            <Tab title="Navigations" primary>
              <Landing />
            </Tab>
            <Tab title="Context Menu">
              <ProductBrowser />
            </Tab>
            <Tab title="Table Demo">
              <TableDemo />
            </Tab>
            <Tab title="Role Layout">
              <RoleLayout />
            </Tab>
            <Tab title="Grid Layout">
              <GridLayout />
            </Tab>
            <Tab title="Material inputs">
              <Material/>
            </Tab>
          </TabStrip>
        </view>
      </view>
    </>
  );
};
export default Template;
